import React from 'react';
import RealTimeContext from "./RealTimeContext";

export default () => (WrappedComponent) => {
    class WithRealTime extends React.Component {
        componentDidMount() {
            this.context.start(this.props.serial);
        }

        render() {
            return <WrappedComponent {...this.props} realTime={this.context.state[this.props.serial]} />
        }
    }

    WithRealTime.contextType = RealTimeContext;

    return WithRealTime;
}
